import { FsMatchTrack } from "db/model/match/Track/FsMatchTrack";
import { Roster } from "model/Roster/Roster";
import { nonUndefined } from "Utility";
import { mapKnockoutRounds } from "./FsKnockoutRound";
import { Scores } from "model/Scores";
import { mapMatchTrackBase } from "../../Track/FsMatchTrack";
import { mapTrackRounds } from "../../Track/FsTrackRound";
import { LivesRules } from "model/Match/Set/Knockout/LivesRules";
import { KnockoutTrack } from "model/Match/Set/Knockout/Track/KnockoutTrack";
import { RosterScope } from "model/Roster/RosterScope";

export const mapKnockoutTracks = (
  fsModels: FsMatchTrack[],
  rosters: Roster[],
  rosterScope: RosterScope,
  runningLives: Scores,
  rules: LivesRules[],
  roundsPerTrack: number | undefined,
  noKoRound: boolean,
  startingLives: number,
  isYekout: boolean
) => {
  const goldenLivesWinners: string[] = [];
  return nonUndefined(
    fsModels.map((t, i) =>
      mapKnockoutTrack(
        t,
        i + 1,
        rosters,
        rosterScope,
        runningLives,
        rules,
        roundsPerTrack,
        noKoRound,
        startingLives,
        isYekout,
        goldenLivesWinners
      )
    )
  );
};

const mapKnockoutTrack = (
  fsModel: FsMatchTrack,
  trackNum: number,
  rosters: Roster[],
  rosterScope: RosterScope,
  runningLives: Scores,
  rules: LivesRules[],
  roundsPerTrack: number | undefined,
  noKoRound: boolean,
  startingLives: number,
  isYekout: boolean,
  goldenLivesWinners: string[]
): KnockoutTrack | undefined => {
  const rounds = mapKnockoutRounds(
    mapTrackRounds(fsModel.rounds ?? []),
    rosters,
    rosterScope,
    trackNum,
    runningLives,
    rules,
    noKoRound,
    startingLives,
    isYekout,
    goldenLivesWinners
  );

  return {
    ...mapMatchTrackBase(fsModel),
    isComplete: !!fsModel.overrideComplete
      ? true
      : !!roundsPerTrack && rounds.length >= roundsPerTrack,
    rounds,
  };
};
